var Search;

Search = function(self, terms) {
  this.terms = terms;
  Selectable(self);
  self.api = function() {
    return api.galleries.search;
  };
  self.assets = (function(_this) {
    return function(options, callback) {
      options.tag_ids = _this.terms;
      return self.api().read(self.gallery_id, options).done(callback);
    };
  })(this);
  return self;
};

if (api.galleries == null) {
  api.add('galleries');
}

api.galleries.add('search');

//# sourceMappingURL=search.js.map
